module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card', [(_vm.request.loading) ? _c('v-card-text', [_c('center', [_c('v-progress-circular', {
    staticClass: "mt-5 mb-3",
    attrs: {
      "size": 70,
      "color": "amber",
      "indeterminate": ""
    }
  }), _c('br'), _vm._v("\n        Logging out\n      ")], 1)], 1) : [(_vm.request.status === 200) ? [_c('v-card-title', {
    staticClass: "subheading justify-center"
  }, [_vm._v("\n          Thank you for spending some time with the Guru\n        ")]), _vm._v(" "), _c('v-card-text', [_c('center', [_c('v-icon', {
    staticClass: "mb-3",
    attrs: {
      "size": 70,
      "color": "info"
    }
  }, [_vm._v("power_off")]), _c('br'), _vm._v("\n            You have successfully been logged out."), _c('br')], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.request.status === 399) ? [_c('v-card-text', [_c('center', [_vm._v("\n            Something went wrong. You have only been partially logged out.\n          ")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Retry logout")])], 1)] : _vm._e()]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dc32cf4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Logout.vue
// module id = 1645
// module chunks = 6